import Box from "@mui/material/Box";
import { FC } from "react";
import { LineCategory } from "~ui-components/components/molecules/legend/shapes/category/line";
import { PointCategory } from "~ui-components/components/molecules/legend/shapes/category/point";
import { PolygonCategory } from "~ui-components/components/molecules/legend/shapes/category/polygon";
import {
	LAYER_STYLE_TYPE,
	LineCategoryConfigs,
	PointCategoryConfigs,
	PolygonCategoryConfigs,
} from "~ui-components/types/__generated/gql/graphql";

export const Category: FC<
	| {
			type: LAYER_STYLE_TYPE.LINE_CATEGORY;
			style: LineCategoryConfigs;
	  }
	| {
			type: LAYER_STYLE_TYPE.POINT_CATEGORY;
			style: PointCategoryConfigs;
	  }
	| {
			type: LAYER_STYLE_TYPE.POLYGON_CATEGORY;
			style: PolygonCategoryConfigs;
	  }
> = ({ type, style }) => {
	return (
		<Box>
			{type === LAYER_STYLE_TYPE.LINE_CATEGORY && (
				<LineCategory style={style} />
			)}
			{type === LAYER_STYLE_TYPE.POINT_CATEGORY && (
				<PointCategory style={style} />
			)}
			{type === LAYER_STYLE_TYPE.POLYGON_CATEGORY && (
				<PolygonCategory style={style} />
			)}
		</Box>
	);
};
